<template>
  <transition name="slide">
    <div v-if="isPanelOpened" class="panel">
      <h3>Edit Product</h3>
      <DxForm ref="editProduct" validation-group="productForm" :form-data="productCopy">
        <DxSimpleItem
          dataField="name"
          :editorOptions="{
            placeholder: 'Product Name',
            stylingMode: 'underlined',
            elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
          }"
          :label="{ visible: false }"
          :validationRules="[{ type: 'required', message: 'Name is required!' }]"
        />
        <DxSimpleItem
          dataField="description"
          :editorOptions="{
            placeholder: 'Product Description',
            stylingMode: 'underlined',
            elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
          }"
          :label="{ visible: false }"
          :validationRules="[{ type: 'required', message: 'Description is required!' }]"
        />
        <DxSimpleItem
          dataField="price"
          editorType="dxNumberBox"
          :editorOptions="{
            placeholder: 'Product Price',
            stylingMode: 'underlined',
            elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
          }"
          :label="{ visible: false }"
          :validationRules="[{ type: 'required', message: 'Price is required!' }]"
        />
        <DxSimpleItem
          dataField="category_id"
          :editorType="'dxSelectBox'"
          :editorOptions="{
            dataSource: categories1,
            displayExpr: 'name',
            valueExpr: 'id',
            value: localSelectedCategory,
            onValueChanged: (e) => { this.localSelectedCategory = e.value; }, // Update localSelectedCategory on change
            placeholder: 'Select Category',
            stylingMode: 'underlined',
            elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
          }"
          :label="{ visible: false }"
          :validationRules="[{ type: 'required', message: 'Category is required!' }]"
        />
      </DxForm>
      <div class="buttons">
          <button type="button" @click="onSave">Save</button>
          <button type="button" @click="onDelete">Delete</button>
          <button type="button" @click="onCancel">Cancel</button>
        </div>
    </div>
  </transition>
</template>

<script>
import { DxForm, DxSimpleItem } from 'devextreme-vue/form';

export default {
  components: {
    DxForm,
    DxSimpleItem
  },
  props: {
    isPanelOpened: Boolean,
    product: Object,
    categories: Array,
    selectedCategory: Number
  },
  data() {
    return {
      productCopy: { ...this.product },
      localSelectedCategory: this.selectedCategory,
      categories1: []
    };
  },
  watch: {
    product(newProduct) {
      this.productCopy = { ...newProduct };
      this.localSelectedCategory = newProduct.category_id;
    },
    selectedCategory(newCategory) {
      this.localSelectedCategory = newCategory;
    }
  },
  created() {
    this.localSelectedCategory = this.selectedCategory;
    this.fetchCategories();
  },
  methods: {
    onSave() {
      this.productCopy.category_id = this.localSelectedCategory;
      this.$emit('saveProduct', this.productCopy);
    },
    onDelete() {
      this.$emit('deleteProduct', this.productCopy.id);
    },
    onCancel() {
      this.$emit('closePanel');
    },
    fetchCategories() {
      fetch(`${process.env.VUE_APP_API_URL}/category/read.php`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => { throw new Error(text); });
        }
        return response.json();
      })
      .then(data => {
        console.log('Fetched categories:', data);
        this.categories1 = data.records;
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      });
    }
  }
};
</script>

<style>
.panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
  padding: 20px;
  overflow-y: auto;
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>